<template>
    <span :class="[
    'badge',
    badgeClass
    ]">
        {{badgeDisplay}}
    </span>
</template>

<script>
export default {
    'props': {
        'statusId': {
            'required': true
        }
    },
    'computed': {
        badgeClass () {
            switch (this.statusId) {
            case 0:return 'badge-primary';
            case 1: return 'badge-success';
            case 2: return 'badge-secondary';
            case 99: return 'badge-dark';
            case 998: return 'badge-danger';
            case 999: return 'badge-warning';
            case 1000: return 'badge-success';
            }
        },
        badgeDisplay () {
            switch (this.statusId) {
            case 0: return 'Awaiting Doctor Response';
            case 1: return 'Doctor Accepted';
            case 2: return 'Ended';
            case 99: return 'Cancelled';
            case 998: return 'Payment Required';
            case 999: return 'No Payment Received';
            case 1000: return 'Appointment Fixed';
            }
        }
    }
};

</script>
